export const isDemoBuild = () => !!process.env.REACT_APP_IS_DEMO_BUILD;
export const isProduction = () => !!process.env.REACT_APP_IS_PRODUCTION;
export const mock = () => {};
